<template>
  <FattureScaduteOneYear />
</template>

<script>
import FattureScaduteOneYear from '@/components/pratiche/FattureScaduteOneYear.vue'

export default {
  components: {
    FattureScaduteOneYear
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

